import { Card, MultipleChart, MultipleChartData } from "components";
import { CardSection } from "../CardSection";
import { GrossProfitMargin } from "../GrafikSection";
import { useEffeciency, useGrossProfitMargin } from "../../utils";
import moment from "moment";
import { convertNumber } from "utils";
import { useState } from "react";

export function Efficiency(params: {
    month?: string | undefined,
    year?: string | undefined,
    location_id?: string
}) {
    return (
        <section>
            <span className="font-bold text-[15px]">Efficiency</span>
            <div className="grid lg:grid-cols-2 mt-2 gap-2">
                <NetProfitMargin
                    month={params.month}
                    year={params.year}
                    location_id={params.location_id}
                />
                <GrossProfitMarginSection
                    month={params.month}
                    year={params.year}
                    location_id={params.location_id}
                />
            </div>
        </section>
    )
}


function NetProfitMargin(params: {
    location_id?: string,
    month?: string | undefined,
    year?: string | undefined
}) {

    const [chartType, setChartType] = useState<"line" | "bar">("line")

    const { data: valueEffeciency } = useEffeciency({
        date: `${params.year}-${params.month}-01`,
        location_id: params.location_id ? params.location_id : ""
    })

    const dataChartNetProfit: MultipleChartData = {
        labels: ["", ...valueEffeciency?.location_net_profit.map((item) => item.location_name) || []],
        datasets: [
            {
                data: [0, ...valueEffeciency?.location_net_profit.map((item) => item.net_profit_margin) || []],
                backgroundColor: chartType === "line" ? ["rgba(128, 0, 128, 0.2)"] : undefined,
                borderColor: ["rgb(128, 0, 128)"],
                fill: false,
            },
        ]
    }

    return (
        <div >
            <Card>
                <Card.Body>
                    <div className="flex justify-between items-start">
                        <div>
                            <div className="text-md text-slate-600 font-bold items-center gap-2">
                                Net profit margin
                            </div>
                            <div className="text-2xl font-bold">{valueEffeciency?.total_net_profit} %</div>
                            <div className="my-3">
                                <span>{moment(`${params.year}-${params.month}`).format("MMMM YYYY")}</span>
                            </div>
                        </div>
                        <div>
                            <MultipleChart.Dropdown
                                value={chartType}
                                onChange={(type) => setChartType(type)}
                            />
                        </div>
                    </div>
                    <div className="mt-[20px] mb-3" >
                        <MultipleChart
                            chartType={chartType}
                            data={dataChartNetProfit}
                            className="h-[150px]"
                        />
                    </div>
                </Card.Body>
            </Card>
        </div>
    )
}

function GrossProfitMarginSection(params: {
    location_id?: string,
    month?: string | undefined,
    year?: string | undefined
}) {

    const { data: valueNetProfit } = useGrossProfitMargin({
        date: `${params.year}-${params.month}-01`,
        location_id: params.location_id ? params.location_id : ""
    })

    return (
        <div>
            <Card>
                <Card.Body>
                    <CardSection
                        label="Gross profit margin"
                        value={`${valueNetProfit?.gross_profit_margin} %`}
                    >
                        <div className="mt-[20px]" >
                            <GrossProfitMargin
                                grosProfitPersent={valueNetProfit?.gross_profit_margin}
                                className="h-[150px]"
                            />
                        </div>

                        <div className="flex justify-center mb-3 gap-2">
                            <div>
                                Sales revenue
                            </div>
                            <div>
                                <strong>{valueNetProfit?.revenue ? convertNumber(valueNetProfit?.revenue).intoCurrency : "-"}</strong>
                            </div>
                        </div>
                    </CardSection>
                </Card.Body>
            </Card>
        </div>
    )
}